<app-page-meta pageTitle="finzy - Borrower Dashboard"></app-page-meta>
<app-header></app-header>

<div class="container-fluid full-height">
  <div class="row d-flex justify-content-center mt-5">
    <div class="col-xs-12 col-md-8">
      <app-borrower-dashboard-breadcrumbs></app-borrower-dashboard-breadcrumbs>
    </div>
  </div>

  <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>

<app-footer></app-footer>